import type { useContactPermissions } from '../../hooks';

// [39787] RBAC is B2B-only: on the colora build `permissions` is undefined and every
// derived value falls back to pre-RBAC behavior — no permission logic runs on B2C.
// Basket rule [44820]: winkelwagen hidden (undefined) only at canorder=false.
export const buildPermissionNavProps = (
  permissions: ReturnType<typeof useContactPermissions>,
  handleBasket: () => void,
  favoritePath: string,
  navigateToProtectedPage: (path?: string) => void,
) => ({
  basketOnClick: permissions && !permissions.canorder ? undefined : handleBasket,
  favoriteOnClick:
    permissions && permissions.showprice === false && permissions.canorder === false
      ? undefined
      : () => navigateToProtectedPage(favoritePath),
  iconLoading: permissions?.loading,
});
